// SPEC §"Browser Support": detect Web Bluetooth on load and surface a
// clear unsupported-browser banner if it's missing. Exported as a
// pure check that takes a navigator-like object so it's trivially
// testable.

export interface BluetoothCapableNavigator {
  readonly bluetooth?: unknown;
}

export function isWebBluetoothAvailable(
  nav: BluetoothCapableNavigator | undefined = typeof navigator !== 'undefined'
    ? (navigator as BluetoothCapableNavigator)
    : undefined,
): boolean {
  return Boolean(nav && nav.bluetooth);
}
